<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and text -->
      <div>
        <b-card-title class="mb-50">
          NEAR Price
        </b-card-title>
        <b-card-text class="mb-0 font-weight-bolder">
          ${{ currentPrice }}
        </b-card-text>
      </div>
      <!--/ title and text -->

      <!-- datepicker -->
      <div class="d-flex align-items-center">
        <feather-icon
          icon="CalendarIcon"
          size="16"
        />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range'}"
          @on-close="changePriceRange"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div>
      <!-- datepicker -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        v-if="loaded"
        :key="refresh"
        type="candlestick"
        height="300"
        :options="apexChartData.priceCandlestick.chartOptions"
        :series="apexChartData.priceCandlestick.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import apexChartData from './apexChartData'
import axios from 'axios'

export default {
  components: {
    BCard,
    VueApexCharts,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardText,
    flatPickr,
  },
  data() {
    return {
      loaded: false,
      currentPrice: 0,
      refresh: false,
      priceDataset: [],
      apexChartData,
      rangePicker: ['2021-12-25', '2022-08-31'],
    }
  },
  methods: {
    changePriceRange(selectedDates, dateStr, instance) {
      apexChartData.priceCandlestick.series[0].data = [] 
      for (let datapoint in this.priceDataset){
        if(this.priceDataset[datapoint].x >= selectedDates[0] && this.priceDataset[datapoint].x <= selectedDates[1]){
          apexChartData.priceCandlestick.series[0].data.push({
            x: this.priceDataset[datapoint].x,
            y: this.priceDataset[datapoint].y
          })
        }
      }
      this.refresh = !this.refresh
    },
  },
  mounted () {
    this.loaded = false
    // query TVL Data
    const priceEndpoint = 'https://api.binance.com/api/v3/klines?symbol=NEARUSDT&interval=12h'
    axios.get(priceEndpoint)
    .then(response => {
      this.currentPrice = Number(response.data[response.data.length-1][4]).toFixed(2)
      apexChartData.priceCandlestick.series[0].data = [] 
      for (let datapoint in response.data){
        var x = new Date(response.data[datapoint][0]) //date
        var y = [
          Number(response.data[datapoint][1]).toFixed(2),
          Number(response.data[datapoint][2]).toFixed(2),
          Number(response.data[datapoint][3]).toFixed(2),
          Number(response.data[datapoint][4]).toFixed(2),
        ]
        apexChartData.priceCandlestick.series[0].data.push({
          x: x,
          y: y
        })
        this.priceDataset.push({
          x: x,
          y: y
        })
      }
      this.loaded = true;
    })
    .catch(e => {
      console.error(e)
    })
  }
}
</script>
